import planData from "../data/plan.json";

export interface VerseRange {
  book: string;
  chapter: number;
  verseStart: number;
  verseEnd: number;
  halfStart?: string;
  halfEnd?: string;
}

export interface ReadingPart {
  label: string;
  raw: string;
  ranges: VerseRange[];
}

export interface PlanDay {
  date: string;
  url: string;
  old: ReadingPart;
  new: ReadingPart;
}

interface PlanFile {
  generatedAt: string;
  days: PlanDay[];
}

const plan = planData as PlanFile;
export const PLAN_DAYS: PlanDay[] = plan.days;

const byDate = new Map<string, PlanDay>();
PLAN_DAYS.forEach((d) => byDate.set(d.date, d));

export const getDay = (key: string): PlanDay | undefined => byDate.get(key);

export const dayIndex = (key: string): number => PLAN_DAYS.findIndex((d) => d.date === key);

export const todayKey = (): string => {
  const now = new Date();
  return `${now.getMonth() + 1}.${now.getDate()}`;
};

export const prevDay = (key: string): PlanDay | undefined => {
  const i = dayIndex(key);
  return i > 0 ? PLAN_DAYS[i - 1] : undefined;
};

export const nextDay = (key: string): PlanDay | undefined => {
  const i = dayIndex(key);
  return i >= 0 && i < PLAN_DAYS.length - 1 ? PLAN_DAYS[i + 1] : undefined;
};

// 阅读计划日期是 M.D（如 8.31），无年份；转成 YYYY-MM-DD 时按参考日期推断最近一轮的年份
// （今年该日期未到则属于去年，否则属于今年），保证每年打卡记录独立
export const dateKeyToApiDate = (key: string, ref = new Date()): string => {
  if (/^\d{4}-\d{2}-\d{2}$/.test(key)) return key;
  const m = key.match(/^(\d{1,2})\.(\d{1,2})$/);
  if (!m) return key;
  const mm = parseInt(m[1], 10);
  const dd = parseInt(m[2], 10);
  const refYear = ref.getFullYear();
  const today = new Date(refYear, ref.getMonth(), ref.getDate());
  const thisYear = new Date(refYear, mm - 1, dd);
  const year = today < thisYear ? refYear - 1 : refYear;
  return `${year}-${String(mm).padStart(2, "0")}-${String(dd).padStart(2, "0")}`;
};
